var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 65,
    viewBox: "0 0 102 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54372 56.387C-0.451714 58.2958 -0.521899 61.4609 1.38695 63.4563C3.2958 65.4517 6.46085 65.5219 8.45628 63.613L1.54372 56.387ZM33.6098 32.6316L37.2118 29.1639L33.7551 25.5732L30.1535 29.0185L33.6098 32.6316ZM49.3171 48.9474L45.715 52.4151L48.911 55.7349L52.4801 52.8198L49.3171 48.9474ZM101.975 10.5016C102.252 7.75415 100.249 5.30228 97.5016 5.02523L52.7287 0.510449C49.9812 0.2334 47.5293 2.23609 47.2523 4.98358C46.9752 7.73107 48.9779 10.1829 51.7254 10.46L91.5236 14.4731L87.5105 54.2713C87.2334 57.0188 89.2361 59.4707 91.9836 59.7477C94.7311 60.0248 97.1829 58.0221 97.46 55.2746L101.975 10.5016ZM8.45628 63.613L37.066 36.2446L30.1535 29.0185L1.54372 56.387L8.45628 63.613ZM30.0077 36.0993L45.715 52.4151L52.9191 45.4796L37.2118 29.1639L30.0077 36.0993ZM52.4801 52.8198L100.163 13.8724L93.837 6.12759L46.1541 45.075L52.4801 52.8198Z",
    fill: "#EAC131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressArrow);
export default __webpack_public_path__ + "static/media/progress_arrow.f60cd1b16b00f69cb14d4fd820f03733.svg";
export { ForwardRef as ReactComponent };